export default __webpack_public_path__ + "static/media/calendar-illustration.42be42ce.png";